import { MonetateExperience } from '@JohnLewisPartnership/experiments-utils';
import Cookies from 'js-cookie';

export const getFlagsFromCookies = (flagNames: Array<string> = []): FeatureFlag[] =>
    flagNames.map((flagName) => {
        return {
            name: flagName,
            isActive: Cookies.get(flagName)?.toLocaleLowerCase() == 'true',
        } as FeatureFlag;
    });

export const isFlagSet = (flagName: string, experiences?: MonetateExperience[]): boolean => {
    const flags = getFlagsFromCookies([flagName]);

    const isEnabledByCookie = flags.length > 0 ? flags[0].isActive : false;
    const isEnabledByExperiment = getFlagFromMonetateExperiences(flagName, experiences);

    return isEnabledByCookie || isEnabledByExperiment;
};

export const getFlagFromMonetateExperiences = (flagName: string, experiences?: MonetateExperience[]): boolean => {
    return (
        experiences?.some((experience) => {
            return experience.parameters && experience.parameters[flagName] === 'true';
        }) || false
    );
};
